import React, { useEffect, useMemo, useRef, useState } from "react";
import { useContextSelector } from "use-context-selector";
import { inRange, isEmpty, startCase, upperCase } from "lodash";
import AuthContext from "../../../context/AuthContext";
import BetSlipContext from "../../../context/BetSlipContext";
import { formatWithCommas } from "../../../Utils/Toast";
const BetSlipSky = () => {
  const numberArray = [10, 100, 200, 500];
  const numberArrayCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, "00", "."];

  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const setBetSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setBetSlipObject;
  });
  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });
  const betLoader = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betLoader;
  });
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });

  const limit = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.limit;
  });
  const setShowBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setShowBetDialog;
  });
  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });
  const setResetBetPosition = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setResetBetPosition;
  });
  const handelPlaceBetFair = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceBetFair;
  });
  const handelPlaceFancy = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceFancy;
  });
  const handelPlaceBookmaker = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceBookmaker;
  });
  const setLoginModal = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setLoginModal;
  });
  const handelPlaceSportBook = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceSportBook;
  });

  const handelPlaceToss = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceToss;
  });
  const [bidPriceDisabled, setBidPricDisabled] = useState(true);
  const [setting, setSetting] = useState(false);
  useEffect(() => {
    if (
      inRange(
        Number(betSlipObject?.bidPrice),
        limit?.minAmount || 1,
        limit?.maxAmount + 1 || 100
      )
    ) {
      setBidPricDisabled(false);
    } else {
      setBidPricDisabled(true);
    }
  }, [betSlipObject, limit]);
  const placeBet = () => {
    if (!isEmpty(user)) {
      if (
        betSlipObject?.playType == "betFaire" ||
        betSlipObject?.playType == "multi" ||
        betSlipObject?.playType == "home"
      ) {
        handelPlaceBetFair();
      } else if (betSlipObject?.playType == "fancy") {
        handelPlaceFancy();
      } else if (betSlipObject?.playType == "bookmaker") {
        handelPlaceBookmaker();
      } else if (betSlipObject?.playType == "sportBook") {
        handelPlaceSportBook();
      } else if (betSlipObject?.playType == "toss") {
        handelPlaceToss();
      }
    } else {
      setShowBetDialog(false);
      setLoginModal(true);
    }
  };

  const inputRef = useRef(null);
  const [activeInput, setActiveInput] = useState(null); // 1 or 2

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [activeInput]);
  return (
    <div id="betBoard_9628769_0_00" className="bet_slip-wrap back">
      {/* <div
        id="messageWrap"
        className="message-wrap"
        style={{ display: "none" }}
      >
        <div className="message">
          <h4 id="header">The Minimun stake is $25.00</h4>
          <p id="info">Your stake has been updated accordingly.</p>
        </div>
        <a id="close" className="close" href="#">
          Close
        </a>
      </div> */}

      <ul className="btn-list">
        <li>
          <p className="dynamic-min-bet">&nbsp;</p>
          <div
            id="inputOdds"
            className={`input-num ${
              ["fancy", "sportBook", "toss", "bookmaker"].includes(
                betSlipObject?.playType
              )
                ? "disable"
                : ""
            } `}
          >
            {!["fancy", "sportBook", "toss", "bookmaker"].includes(
              betSlipObject?.playType
            ) && <div id="oddsDown" className="icon-minus icon-odds" />}
            <span id="odds" className="typed">
              {betSlipObject?.odds}
            </span>
            {!["fancy", "sportBook", "toss", "bookmaker"].includes(
              betSlipObject?.playType
            ) && <div id="oddsUp" className="icon-plus icon-odds" />}
          </div>
        </li>
        <li>
          <p className="dynamic-min-bet">
            Min Bet:{" "}
            <strong id="dynamicMinBet">
              {formatWithCommas(limit?.minAmount)}
            </strong>
          </p>
          <div id="inputStake" className="input-num input-stake">
            <div
              onClick={(e) => {
                if (betSlipObject?.bidPrice > 1) {
                  setBetSlipObject({
                    ...betSlipObject,
                    bidPrice: Number(betSlipObject?.bidPrice) - 1,
                  });
                }
              }}
              id="stakeDown"
              className="icon-minus icon-odds"
            />
            <span id="stake" className="typed">
              {betSlipObject?.bidPrice}
            </span>
            <div
              onClick={(e) => {
                if (betSlipObject?.bidPrice > 0) {
                  setBetSlipObject({
                    ...betSlipObject,
                    bidPrice: Number(betSlipObject?.bidPrice) + 1,
                  });
                }
              }}
              id="stakeUp"
              className="icon-plus icon-odds"
            />
          </div>
        </li>
      </ul>
      <ul id="stakePopupList" className="coin-list">
        {(profileData?.stake?.length > 0
          ? profileData?.stake?.sort(function (a, b) {
              return a - b;
            })
          : numberArray
        )
          ?.slice(0, 5)
          ?.map((res) => {
            return (
              <li
                onClick={() => {
                  setBetSlipObject({
                    ...betSlipObject,
                    bidPrice: Number(res),
                  });
                }}
              >
                <div className="coin-list-a" id="selectStake_1">
                  {res}
                </div>
              </li>
            );
          })}
      </ul>
      <div id="keyboard" className="keyboard-wrap">
        <ul id="numPad" className="btn-tel">
          {numberArrayCount?.map((res) => {
            return (
              <li
                onClick={() =>
                  setBetSlipObject((prev) => {
                    return {
                      ...prev,
                      bidPrice:
                        Number(prev?.bidPrice) > 0
                          ? Number(String(prev?.bidPrice) + String(res))
                          : Number(res),
                    };
                  })
                }
              >
                <div className="btn-tel-a">{res}</div>
              </li>
            );
          })}
        </ul>
        <div
          onClick={() => {
            if (!betSlipObject?.bidPrice) return;
            const newValue = String(betSlipObject?.bidPrice).slice(0, -1);
            setBetSlipObject({
              ...betSlipObject,
              bidPrice: Number(newValue),
            });
          }}
          id="delete"
          className="btn-delete"
        />
      </div>
      <ul className="btn-list">
        <li
          onClick={() => {
            setShowBetDialog(false);
            setResetBetPosition(true);
          }}
        >
          <div id="cancel" className="btn">
            Cancel
          </div>
        </li>
        <li
          onClick={() => {
            placeBet();
          }}
          disabled={bidPriceDisabled}
        >
          <div
            id="placeBet"
            className={`btn-send ${bidPriceDisabled ? "disable" : ""} `}
          >
            Place Bet
          </div>
        </li>
      </ul>
    </div>
  );
};

export default BetSlipSky;
